import { usePathname } from 'expo-router';
import { useEffect } from 'react';
import { Platform, StyleSheet, View } from 'react-native';

import { useAppStore } from '@/src/state/app-store';
import { colors } from '@/src/theme/colors';

export function ProfileNavigationOverlay() {
  const pathname = usePathname();
  const targetUid = useAppStore((state) => state.profileNavigationTargetUid);
  const setTargetUid = useAppStore(
    (state) => state.setProfileNavigationTargetUid,
  );

  useEffect(() => {
    if (!targetUid) {
      return undefined;
    }

    const timeout = setTimeout(() => setTargetUid(null), 1200);

    return () => clearTimeout(timeout);
  }, [setTargetUid, targetUid]);

  useEffect(() => {
    if (!targetUid || pathname !== `/users/${targetUid}`) {
      return undefined;
    }

    const timeout = setTimeout(() => setTargetUid(null), 120);

    return () => clearTimeout(timeout);
  }, [pathname, setTargetUid, targetUid]);

  if (Platform.OS !== 'web' || !targetUid) {
    return null;
  }

  return <View pointerEvents="none" style={styles.overlay} />;
}

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: colors.background,
    elevation: 1000,
    zIndex: 1000,
  },
});
